var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm.temp
      ? _c(
          "div",
          { staticClass: "middleImg middleImg1" },
          [
            _c("div", { staticClass: "loginFormName loginFormName1" }, [
              _vm._v("注册账号")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "line" }),
            _vm._v(" "),
            _c(
              "Form",
              {
                ref: "form",
                staticClass: "myForms",
                attrs: { model: _vm.formItem }
              },
              [
                _c(
                  "FormItem",
                  { attrs: { label: "业主单位：" } },
                  [
                    _c(
                      "Select",
                      {
                        attrs: { placeholder: "" },
                        on: { "on-change": _vm.selectowner },
                        model: {
                          value: _vm.formItem.bownerId,
                          callback: function($$v) {
                            _vm.$set(_vm.formItem, "bownerId", $$v)
                          },
                          expression: "formItem.bownerId"
                        }
                      },
                      _vm._l(_vm.ownerList, function(item) {
                        return _c(
                          "Option",
                          { key: item.id, attrs: { value: item.id } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormItem",
                  { attrs: { label: "所属部门：" } },
                  [
                    _c(
                      "Select",
                      {
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.formItem.sysDepartmentId,
                          callback: function($$v) {
                            _vm.$set(_vm.formItem, "sysDepartmentId", $$v)
                          },
                          expression: "formItem.sysDepartmentId"
                        }
                      },
                      _vm._l(_vm.departmentList, function(item) {
                        return _c(
                          "Option",
                          { key: item.id, attrs: { value: item.id } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormItem",
                  { attrs: { label: "真实姓名：" } },
                  [
                    _c("Input", {
                      model: {
                        value: _vm.formItem.name,
                        callback: function($$v) {
                          _vm.$set(_vm.formItem, "name", $$v)
                        },
                        expression: "formItem.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormItem",
                  { attrs: { label: "手机号码：" } },
                  [
                    _c("Input", {
                      model: {
                        value: _vm.formItem.mobile,
                        callback: function($$v) {
                          _vm.$set(_vm.formItem, "mobile", $$v)
                        },
                        expression: "formItem.mobile"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormItem",
                  { attrs: { label: "验证码：" } },
                  [
                    _c("Input", {
                      staticClass: "code",
                      model: {
                        value: _vm.formItem.code,
                        callback: function($$v) {
                          _vm.$set(_vm.formItem, "code", $$v)
                        },
                        expression: "formItem.code"
                      }
                    }),
                    _vm._v(" "),
                    _vm.tempCode
                      ? _c(
                          "div",
                          {
                            staticClass: "sendCode",
                            on: {
                              click: function($event) {
                                return _vm.getCode()
                              }
                            }
                          },
                          [_vm._v("发送验证码")]
                        )
                      : _c(
                          "div",
                          { staticClass: "sendCode", attrs: { disabled: "" } },
                          [_vm._v(_vm._s(_vm.text) + "s后发送")]
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.flag1
                  ? _c(
                      "FormItem",
                      { attrs: { label: "设置密码：" } },
                      [
                        _c("Input", {
                          attrs: { type: "password" },
                          model: {
                            value: _vm.formItem.password,
                            callback: function($$v) {
                              _vm.$set(_vm.formItem, "password", $$v)
                            },
                            expression: "formItem.password"
                          }
                        }),
                        _vm._v(" "),
                        _c("Icon", {
                          staticClass: "myPassword1",
                          attrs: { type: "ios-eye-off-outline" },
                          on: { click: _vm.handlePassword1 }
                        })
                      ],
                      1
                    )
                  : _c(
                      "FormItem",
                      { attrs: { label: "设置密码：" } },
                      [
                        _c("Input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.formItem.password,
                            callback: function($$v) {
                              _vm.$set(_vm.formItem, "password", $$v)
                            },
                            expression: "formItem.password"
                          }
                        }),
                        _vm._v(" "),
                        _c("Icon", {
                          staticClass: "myPassword1",
                          attrs: { type: "ios-eye-outline" },
                          on: { click: _vm.handlePassword1 }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.flag2
                  ? _c(
                      "FormItem",
                      { attrs: { label: "确认密码：" } },
                      [
                        _c("Input", {
                          attrs: { type: "password" },
                          model: {
                            value: _vm.formItem.confirmPassword,
                            callback: function($$v) {
                              _vm.$set(_vm.formItem, "confirmPassword", $$v)
                            },
                            expression: "formItem.confirmPassword"
                          }
                        }),
                        _vm._v(" "),
                        _c("Icon", {
                          staticClass: "myPassword1",
                          attrs: { type: "ios-eye-off-outline" },
                          on: { click: _vm.handlePassword2 }
                        })
                      ],
                      1
                    )
                  : _c(
                      "FormItem",
                      { attrs: { label: "确认密码：" } },
                      [
                        _c("Input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.formItem.confirmPassword,
                            callback: function($$v) {
                              _vm.$set(_vm.formItem, "confirmPassword", $$v)
                            },
                            expression: "formItem.confirmPassword"
                          }
                        }),
                        _vm._v(" "),
                        _c("Icon", {
                          staticClass: "myPassword1",
                          attrs: { type: "ios-eye-outline" },
                          on: { click: _vm.handlePassword2 }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "FormItem",
                  { attrs: { label: "单位邀请码：" } },
                  [
                    _c("Input", {
                      model: {
                        value: _vm.formItem.authCode,
                        callback: function($$v) {
                          _vm.$set(_vm.formItem, "authCode", $$v)
                        },
                        expression: "formItem.authCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bottonDiv bottonDiv1",
                on: {
                  click: function($event) {
                    return _vm.register()
                  }
                }
              },
              [_vm._v("注册")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "toRegister",
                on: {
                  click: function($event) {
                    return _vm.toRegister(false)
                  }
                }
              },
              [_vm._v("已有账号，去登录→")]
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "middleImg" },
          [
            _c("div", { staticClass: "loginFormName" }, [_vm._v("欢迎登录")]),
            _vm._v(" "),
            _c("div", { staticClass: "line" }),
            _vm._v(" "),
            _c("Input", {
              staticClass: "myInput",
              attrs: { prefix: "ios-person", placeholder: "用户名" },
              model: {
                value: _vm.user,
                callback: function($$v) {
                  _vm.user = $$v
                },
                expression: "user"
              }
            }),
            _vm._v(" "),
            _vm.flag
              ? _c(
                  "div",
                  [
                    _c("Input", {
                      staticClass: "myInput myInput1",
                      attrs: {
                        prefix: "ios-lock",
                        placeholder: "密码",
                        type: "password"
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    }),
                    _vm._v(" "),
                    _c("Icon", {
                      staticClass: "myPassword",
                      attrs: { type: "ios-eye-off-outline" },
                      on: { click: _vm.handlePassword }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("Input", {
                      staticClass: "myInput myInput1",
                      attrs: {
                        prefix: "ios-lock",
                        type: "text",
                        placeholder: "密码"
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    }),
                    _vm._v(" "),
                    _c("Icon", {
                      staticClass: "myPassword",
                      attrs: { type: "ios-eye-outline" },
                      on: { click: _vm.handlePassword }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bottonDiv",
                on: {
                  click: function($event) {
                    return _vm.login()
                  }
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.login()
                  }
                }
              },
              [_vm._v("登录")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "toRegister",
                on: {
                  click: function($event) {
                    return _vm.toRegister(true)
                  }
                }
              },
              [_vm._v("还没账号，去注册→")]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("../../static/image/logo.png") }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "logoName" }, [_vm._v("普华维保管理平台")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "erCode" }, [
      _c("img", {
        staticClass: "erCodeImg",
        attrs: { src: require("../../static/image/eCode.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "erCodeText" }, [_vm._v("扫一扫，下载App")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c40149d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c40149d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = null
// module chunks = 